import {
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function deleteImageFromGalery(index, images, image) {
  return async dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_BEGIN
    })

    let error = null
    images.splice(index, 1)

    if (image.deviceImage) {
      try {
        await BFFAgent.Files.deleteFile(image.id)
      } catch {
        error = true
      }
    }
    
    if (!error) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_SUCCESS,
        data: images
      })
    } else {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_DELETE_IMAGE_FAILURE,
        data: images
      })
    }
  }
}
